import { getContentfulLocale } from '../../../../features/src/i18n/locales/index';
import { isContentReleased } from '../../../utils/dateUtils';

// Shared content validation function for locale checking
export function isValidContentForLocale(item: any, locale: string): boolean {
  // English content is always valid
  if (locale === 'en') {
    return true;
  }

  // Check if item has translated flag
  if (item.translated === true) {
    return true;
  }

  // Check if it's customGridContent (always valid if passed)
  if (item.contentType === 'customGridContent') {
    return true;
  }

  // Check if item has languages field with the locale
  if (item.languages) {
    return item.languages.split(',').indexOf(getContentfulLocale(locale)) >= 0;
  }

  return false;
}

/**
 * Validation logic extracted from itemToSearchHit to filter out invalid items
 * including circular references, missing required fields, and unreleased content
 */
export function isValidGridItem(item: any, locale: string): boolean {
  // Check for circular references (these don't have the required fields)
  if (item?.sys?.circular) {
    return false;
  }

  // Check for required content type
  const ctype = item?.contentType as string;
  if (!ctype) {
    return false;
  }

  // Check for required ID
  if (!item?.id) {
    return false;
  }

  // Check for required URL (either urlSlug or url)
  if (!(item?.urlSlug || item?.url)) {
    return false;
  }

  // Check if content is released (skip future release dates)
  if (item?.releaseDate && !isContentReleased(item.releaseDate)) {
    return false;
  }

  // Use shared locale validation
  if (!isValidContentForLocale(item, locale)) {
    return false;
  }

  return true;
}
